import moment from 'moment';
import { cloneDeep } from 'lodash';

const _ = { cloneDeep };

export default (courtOop) => {
    const oopSeq = _.cloneDeep(courtOop);
    oopSeq.sort((a, b) => a.sequenceNumber - b.sequenceNumber);
    let errors = null;
    let maxDate;
    oopSeq.forEach((matchOop) => {
        if (matchOop.includesTime) {
            if (!maxDate) {
                maxDate = moment.utc(matchOop.date);
            } else if (moment.utc(matchOop.date).isAfter(maxDate)) {
                maxDate = moment.utc(matchOop.date);
            } else if (moment.utc(matchOop.date).isSameOrBefore(maxDate)) {
                if (!errors) {
                    errors = {};
                }
                errors[matchOop.matchId] = 'Match sequence invalid';
            }
        }
    });
    return errors;
};
